namespace GeniuzPOS.Administration {
    export interface SysParaForm {
        SysFg: Serenity.IntegerEditor;
        SysGroup: Serenity.LookupEditor;
        SysName: Serenity.StringEditor;
        SysDesc: Serenity.StringEditor;
        SysFgDesc: Serenity.StringEditor;
    }

    export class SysParaForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.SysPara';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SysParaForm.init)  {
                SysParaForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;

                Q.initFormType(SysParaForm, [
                    'SysFg', w0,
                    'SysGroup', w1,
                    'SysName', w2,
                    'SysDesc', w2,
                    'SysFgDesc', w2
                ]);
            }
        }
    }
}
